import { defineComponent as r, createBlock as l, openBlock as n, normalizeProps as p, guardReactiveProps as a, withCtx as s, renderSlot as m, createElementVNode as d } from "vue";
import i from "../CdrIcon.vue.mjs";
const f = /* @__PURE__ */ r({
  name: "XLg",
  __name: "x-lg",
  props: {
    props: {
      type: Object
    }
  },
  setup(t) {
    return (o, e) => (n(), l(i, p(a(t.props)), {
      default: s(() => [m(o.$slots, "default"), e[0] || (e[0] = d("path", {
        role: "presentation",
        d: "M13.415 12.006l5.295-5.292a1 1 0 00-1.414-1.415L12 10.591 6.71 5.296A1 1 0 005.295 6.71l5.292 5.295-5.295 5.292a1 1 0 101.414 1.414l5.295-5.292 5.292 5.295a1 1 0 001.414-1.414l-5.292-5.294z"
      }, null, -1))]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
